<template>

	<footer class="container a-page e-footer" id="footer" v-if="showWebFooter">
		<div class="inner-background">

		<div class="container-upsell a-footer e-upsell" v-if="!loggedIn">
			<div class="a-upsell e-site-upsell" id="site-upsell">
				<div class="footer-upsell">
					<h3>Discover a healthier way to read the news.</h3>
					<button class="btn" @click="showSignUp()">
						Get started
						<svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path fill-rule="evenodd" clip-rule="evenodd" d="M8.88355 11.6569C8.68829 11.8521 8.37171 11.8521 8.17645 11.6569C7.98118 11.4616 7.98118 11.145 8.17645 10.9498L12.6262 6.49999L0.5 6.49999C0.223857 6.49999 4.70472e-07 6.27613 4.46331e-07 5.99999C4.2219e-07 5.72385 0.223857 5.49999 0.5 5.49999L12.6262 5.49999L8.17645 1.05021C7.98118 0.854947 7.98118 0.538364 8.17645 0.343102C8.37171 0.14784 8.68829 0.14784 8.88355 0.343102L14.1869 5.64644C14.3821 5.8417 14.3821 6.15828 14.1869 6.35354L8.88355 11.6569Z" fill="white"/>
						</svg>
        </button>
				</div>
			</div>
		</div>

		<div class="container-wrapper">
			<div class="container-inner a-footer e-links">
				<div class="a-links e-site-info-links" id="site-info-links">

					<div class="flex logo-wrapper">
						<base-svg svg="logo" height="1.75rem"/>
						<!-- <ul class="social-list right h-list">
							<li class="twitter">
								<a href="https://twitter.com/onesub_" target="_blank" title="Check out our Twitter!"></a>
							</li>

							<li class="facebook">
								<a href="https://www.facebook.com/justonesub" target="_blank" title="Check out our Facebook!"></a>
							</li>

							<li class="linkedin">
								<a href="https://www.linkedin.com/company/onesub" target="_blank" title="Check out our LinkedIn!"></a>
							</li>
						</ul> -->
					</div>

					<div class="footer-content">
						<div class="links">
							<RouterLink to="/mission" class="ghost">Mission</RouterLink>
							<RouterLink to="/contact" class="ghost">Contact</RouterLink>
							<RouterLink to="/terms" class="ghost">Terms</RouterLink>
							<RouterLink to="/privacy" class="ghost">Privacy</RouterLink>
						</div>

						<span>
							© 2025 OneSub Ltd
							•	<a style="cursor:pointer;" :class="{'pref-active' : (themeMode == 'lightmode')}" @click="setThemeMode('lightmode')">Light</a>
							•	<a style="cursor:pointer;" :class="{'pref-active' : (themeMode == 'darkmode')}" @click="setThemeMode('darkmode')">Dark</a>
							•	<a style="cursor:pointer;" :class="{'pref-active' : (themeMode == 'auto')}" @click="setThemeMode('auto')">Auto</a>

						</span>
					</div>
<!-- 
					<div class="flex footer-down">
						<div class="flex-footer-links">
							
								<ul class="footer-link h-list">

									<li>
										<router-link to="/" title="Stories">Stories</router-link>
									</li>
									<li>
										<a :href="`https://${documentURL}/mission/`" title="Our Mission">Mission</a>
									</li>
									<li>
										<a :href="`https://${documentURL}/pledges/`" title="Our Mission">Pledges</a>
									</li>
									<li>
										<a :href="`https://${documentURL}/contact/`" title="Get In Touch">Contact</a>
									</li>
									<li>
										<router-link to="/blog" title="Blog">Blog</router-link>
									</li>
									<li>
										<a :href="`https://intercom.help/onesub/en`" target="_blankup" title="Help & Support">Help</a>
									</li>
									<li>
										<a :href="`https://${documentURL}/privacy/`" title="Privacy Policy">Privacy</a>
									</li>
									<li>
										<a :href="`https://${documentURL}/terms/`" title="Terms & Conditions">Terms</a>
									</li>
									<li v-if="!loggedIn">
										<span v-on:click="showSignIn" title="Sign In">Sign In</span>
									</li>
									<li v-else>
										<span v-on:click="triggerSignOut" title="Sign Out">Sign Out</span>
									</li>
									<li>
											<a :class="{'pref-active' : (themeMode == 'lightmode')}" @click="setThemeMode('lightmode')">Light</a>
									</li>
									<li>
											<a :class="{'pref-active' : (themeMode == 'darkmode')}" @click="setThemeMode('darkmode')">Dark</a>
									</li>
									<li>
											<a :class="{'pref-active' : (themeMode == 'auto')}" @click="setThemeMode('auto')">Auto</a>
									</li>
									<li>
										<a href="javascript:document.location.reload(true);">Build - API:{{ build }} | App: {{ htmlBuild }}</a>
									</li>
								</ul>

							<div v-if="topics.length">
								<h2>Trending Topics</h2>
								<ul class="footer-link h-list">
									<li v-for="tag in topics.slice(0, 5)" :key="tag.code">
										<span v-on:click="emitClick(tag)" :class="{ 'router-link-exact-active' : checkActive(tag.code) }">{{ tag.name }}</span>
									</li>
								</ul>
							</div>
						</div>
						<div class="a-links e-site-copyright" id="site-copyright">
							<p>
								Piccadilly House, Bath, BA1 6PL / <a href="mailto:hello@nourished.news">hello@nourished.news</a><br/>
								&copy; OneSub - 2022 - All Rights Reserved
							</p>
						</div>
					</div> -->
				</div>
				</div>

			</div>
		</div>

	</footer>
</template>

<script>

// import API from "app/axios.js";


export default {
	name: 'Footer',
	data() {
		return {
			topics: []
		}
	},
	mounted() {
		// let fetchArticles = API.get(`/topics/trending?src=foot`);
		// fetchArticles.then((response) => {
		// 	this.topics = response.data;
		// })
		// .catch((error) => {
		// 	// eslint-disable-next-line
		// 	console.error(error);
		// });
	},
	computed: {
		loggedIn() {
			return this.$store.getters.isLoggedIn;
		},
		documentURL() {
			return document.domain;
		},
    showWebFooter() {
      return true; // this.$route?.meta?.display?.web_footer != 'hide';
    },
    themeMode() {
      return this.$userEngine.getPref('layout.theme');
    },
		build() {
			return this.$store.getters.getAccount?.build?.client;
		},
		htmlBuild() {
			return this.$store.getters.getHtmlBuild;
		},
	},
	props: {

	},
	methods: {
    setThemeMode(sMode) {
      this.$userEngine.setPref('layout.theme', sMode);
    },
		triggerSignOut() {
			if (localStorage) {
				localStorage.removeItem('token');
			}

			this.EventBus.$emit("appCallback", {
				type: 'deauthCallback',
				data: 'logout'
      });
      
      // Clear the store..
      this.$store.commit('unsetAccount');
			
			setTimeout(() => {
				window.location = `https://${this.documentURL}/r/x/logout`;
			}, 500);
		},
		emitClick(tag) {
			this.$router.push(`/topic/${tag.code}`).catch(() => {});
		},
		checkActive(item) {
			return item == this.$route.params.name
		},
		showSignUp() {
			this.$store.commit("updateShowModal", 'skip');
		},
		showSignIn() {
			this.EventBus.$emit('showLoginModal', 'clean');
		}
	}
};
</script>


<style lang="scss" scoped>
	@import '~styles/_variables';
	@import 'src/assets/scss/v5.scss';

	.footer-content {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		padding: 2rem 0 0 0;
		color: $neutral-400;
		font-size: 18px;

		.links {
			display: flex;
			padding-bottom: 2rem;

			.ghost {
				color: $neutral-400;
				margin-right: 1rem;
				border-bottom: 0;

				&:hover {
					color: $neutral-100;

					.darkmode & {
						color: $neutral-600;
					}
				}
			};
		}

		span {
			font-size: 14px;
		}
	}

	footer {
		background: $neutral-600;
		
		.darkmode & {
			background: rgb(0,0,0);
		}

		@media (max-width: 450px) {
			padding-bottom: 4.5rem;
		}

    .pref-active {
      text-decoration: underline !important;
    }

    font-family: $ff-tag !important;
		.inner-background {
			@include palette-block;
		}

		.container-upsell {
			padding: 3em 1em;
			text-align: center;
			border-top: 1px solid rgba($neutral-400, 0.25);
			background: $neutral-600;

			@media (max-width: 450px) {
			padding-bottom: 4.5rem;
		}

			.darkmode & {
				background: rgb(0,0,0);
				color: $neutral-600;
			}

			.btn {
				padding: 1.1rem 2.5rem 1.2rem 2.5rem;
				border-radius: 500px;
				font-size: 18px;
				font-weight: normal;

				svg {
					margin-left: 0.5rem;

					path {
						fill: $neutral-100;
					}
				}
			}

			button {
        font-weight: normal;
        font-size: 18px;
        color: rgb(0,0,0);
        padding-bottom: 0.25rem;
        border-radius: 0;

        svg {
          margin-left: 0.4rem;

          path {
            fill: rgb(0,0,0);
          }
        }
      }
		}

		.container-upsell h3 {
			font-weight: bold;
			margin-bottom: 2rem;
			margin-top: 0;
			line-height: 26px;
		}

		.container-wrapper {
			// border-top: 1px solid rgba($neutral-400, 0.25);
			background: $neutral-600;

			.darkmode & {
				background: rgb(0,0,0);
			}
		}

		.container-inner {
			max-width: 1400px;
			margin: 0 auto;
			padding: 50px 1.5rem;
			background: $neutral-600;

			.darkmode & {
				background: rgb(0,0,0);
			}
		}

		.flex {
			align-items: center;
			justify-content: space-between;
			> * {
				// flex: 1;
			}
		}

		.logo-wrapper {
			margin-bottom: 2em;
			align-items: center;
		}

		p {
			font-family: $ff-body;
			font-size: 12px;
			color: rgb(157, 169, 169);
			letter-spacing: 0;
			line-height: 24px
		}

		p a {
			color: rgb(157, 169, 169);
			transition: all 0.2s ease-in-out;
			&:hover {
				color: darken(#9da9a9, 30%);
			}

		}

    .h-list > li {
      float: left;
      margin-right: .5em;
    }

		.e-site-copyright {
			text-align: right;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			p:first-of-type {
				margin-top: 0;
			}

			p:last-of-type {
				margin-bottom: 0;
			}
		}

		.social-list {
			display: flex;
			justify-content: flex-end;
		}

		.social-list li {
			margin: 0;
			margin-left: 5px;
			float: left;
		}

		.social-list a {
			width: 32px;
			height: 32px;
			display: block;
			text-indent: -9999px;
			overflow: hidden;
			border-radius: 50%;
			transition: all 0.2s ease-in-out;
		}

		.footer-link li {
			padding: 0;
			// margin: 0;
			border: 0;
			text-transform: capitalize;
		}

		.footer-link li a {
			text-decoration: none;
		}

		.opacity-logo {
			justify-content: flex-start;
		}

		.flex-footer-links {
			display: flex;
      margin-top: auto;
		}

		.footer-down {
			align-items: initial;
		}

		.flex-footer-links div + div {
			margin-left: 8em;
		}

		.flex-footer-links li a,
		.flex-footer-links li span {
			opacity: .9;
			color: rgb(157, 169, 169);
			font-family: $ff-book; // ;
			font-size: 12px;
			font-weight: bold;
			line-height: 22px;
			cursor: pointer;
			transition: all 0.2s ease-in-out;
			&:hover {
				color: darken(rgb(157, 169, 169), 30%);
			}
		}

		.flex-footer-links h2 {
			opacity: .9;
			color: rgb(118, 129, 129);
			font-size: 14px;
			font-weight: bold;
			line-height: 17px;
			margin-bottom: .75em;
			margin-top: 0;
		}

		@media (min-width: 600px) {
			.footer-upsell {
				max-width: 1400px;
				margin: auto;
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 1rem 1em;
				h3 {
					font-family: 'Brawler';
					font-weight: normal;
					font-size: 30px;
					line-height: 130%;
					margin-bottom: 0;
					flex: 1;
					text-align: left;
					padding-right: 1.5em;
				}
			}
		}

		@media(max-width: 600px) {

			.container-upsell {
				padding: 3rem 1.5em;
			}

			.footer-upsell {
				h3 {
					font-family: 'Brawler';
					font-weight: normal;
					font-size: 30px;
					line-height: 130%;
				}
			}

			.footer-down {
				flex-wrap: wrap;
				flex-wrap: wrap;
				justify-content: initial;
				align-items: initial;
				flex-direction: column;
				.flex-footer-links {
					width: 100%;
				}
			}

			.e-site-copyright {
				align-items: flex-start;
				text-align: left;
				margin-top: 2em;
			}
		}
	}
</style>
